import { createContext } from "react";

const SeatContext = createContext();

export default SeatContext;